module.exports = vendor_96a0480f35d3a07b6c08;